var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-cards"},_vm._l((_vm.articles),function(article,idx){return _c('ArticleCard',{key:_vm.getKey('ArticleCard', idx),staticClass:"article-cards__card",attrs:{"article":article}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }